module.exports = __webpack_public_path__ + "static/media/The-Heights-at-Elkow-Farms-Master-Deed.0f66c605.pdf";